<template>
  <v-container class="text-center pr-0 pl-0" fluid>
    <v-card class="elevation-2">
      <v-card-text>
        <v-autocomplete
          v-model="selectedItem"
          :items="atletaList"
          item-value="item"
          item-text="fullName"
          min="3"
          outlined
          dense
          label="Digite para filtrar..."
          prepend-inner-icon="mdi-account-search-outline"
          clearable
          return-object
          @click:clear="selectedItem = null"
        ></v-autocomplete>
      </v-card-text>
    </v-card>

    <v-card v-for="item in atletaList" :key="item.id" class="">
      <v-card-title class="title mt-2 pt-1 pb-1 primary lighten-1">
        <v-avatar v-if="item.profile != null" class="mr-4">
          <img :src="item.profile.media.url">
        </v-avatar>
        {{item.fullName}}
      </v-card-title>
      <v-card-text class="pt-2 pb-3 text-left ml-5 pr-5">
        
        <v-row class="">
          <v-col cols="12" xl="12" lg="12" md="12" sm="12" class="pt-0 pb-0 pr-4">
            <span class="body-2">"{{item.profile.frase}}"</span>
          </v-col>
        </v-row>
        <v-row class="text-right">
          <v-col cols="12" xl="12" lg="12" md="12" sm="12" class="pt-3 pb-0 pr-5">
            <span class="caption">Conosco desde {{item.formattedCreatedDate}}</span>
          </v-col>
        </v-row>

      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn fab color="primary lighten-1" x-small primary>
          <v-icon color="black">mdi-cards-heart</v-icon>
        </v-btn>
        <v-btn fab color="primary lighten-1" x-small primary>
          <v-icon color="black">mdi-plus</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>

    
  </v-container>
</template>

<script>

import Atletas from '../fake-data/Alunos'
import HOST from '../ws'
//import SnackBar from "../snackbar";

export default {
  props: {
    source: String
  },
  data: () => ({

    myHost : HOST.HOST,
    searchItems : Atletas.ALUNOS,

    selectedItem: null,
    value: null,

    atletaList : [],
  }),
  mounted (){
    this.reloadAtletaList();
  },
  methods : {
    reloadAtletaList(){
      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.currentToken}` }
      };
      this.axios
      .post(this.myHost + '/user/atletascomprofile', {}, config)
      .then(response => {
        this.atletaList = response.data;
      })
      .catch((error) => {
         console.log(error.message);
         this.$store.commit('logout');
         this.$router.push("/");
      });
    }
  }

};
</script>